import React, { useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { useLazyQuery } from "@apollo/client";
import { setUserProfile } from "./UserProfiles";
import { UserContext } from "./UserContext";
import { GET_LOGGEDIN_USER_QUERY } from "../../../queries/ddwAdminQrys/UserManagementQrys";

// Define the storage key for the Access Token
const ACCESS_TOKEN_KEY = "token"; 

const CallbackPage = () => {
  const history = useHistory();
  const { user, setUser } = useContext(UserContext);
  const [getLoggedInUser] = useLazyQuery(GET_LOGGEDIN_USER_QUERY, { fetchPolicy: "no-cache" });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let accessToken = params.get("auth"); // Use "auth" as per Lambda's redirect
    let idToken = params.get("id_token"); // Keep ID Token for user claims if needed

    try {
      // Check if the Access Token exists
      if (accessToken) {
        // Decode the ID Token or Access Token (use Access Token for expiration check)
        const tokenToCheck = idToken || accessToken;

        if (!tokenToCheck) {
          console.error("Missing primary token in redirect.");
          history.push("/");
          return;
        }

        const decodedToken = jwtDecode(tokenToCheck);
        const tokenExp = new Date(decodedToken.exp * 1000);

        // If the token has already expired (unlikely in a redirect, but good check)
        if (new Date() > tokenExp)
        {
          console.warn("Received expired token on callback.");
          sessionStorage.removeItem(ACCESS_TOKEN_KEY);
          sessionStorage.removeItem("user");
          history.push("/");
          return;
        }

        // Store the Access Token (this is the key change from your previous token setting)
        sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

        getLoggedInUser().then((res) => {
          if (res.data === undefined || res.data === null) {
            sessionStorage.setItem("auth", JSON.stringify(false));
            history.push("/not-authorized");
          } else {
            sessionStorage.setItem("auth", JSON.stringify(true));
            // Use the Access Token to set the profile (or ID Token if required by setUserProfile)
            let user = setUserProfile(res.data.getLoggedInUser, accessToken); 
            setUser(user);
            sessionStorage.setItem("user", JSON.stringify(user));

            if (user.permissions.length === 0) {
              sessionStorage.setItem("route", "public/request-access");
            } 
          }
          if (sessionStorage.route) {
            history.push(sessionStorage.getItem("route"));
          } else {
            history.push("/");
          }
        });
      }
    } catch (err) {
      console.error("ERROR during token processing or user query: ", err);
      // Clear session on fatal error and redirect to prevent loops
      sessionStorage.clear();
      history.push("/");
    }
  }, [getLoggedInUser, user, history, setUser]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    try {
      if (params.has("revoke")) {
        setUser({
          isPublic: true,
          isStaff: false,
          isSysAdmin: false,
          isPortalUser: false
        });
        sessionStorage.clear();
        history.push("/");
      }
    } catch (err) {
      console.error("Error occured during logout: ", err);
    }
  }, [setUser, history]);

  return (
    <Row>
      <Col>
        <em>Redirecting ...</em>
      </Col>
    </Row>
  );
};

export default CallbackPage;